<template>
  <div class="stocks">
    <DefBreadCrumbs />
    <DefTitle :result="1">
      <h1 v-if="messages">{{ messages.title }}</h1>
    </DefTitle>
    <section v-if="items && items.length" class="stocks__items pagination-scroll-js">
      <StocksCard v-for="item in items" :key="item.id" :result="item" :messages="messages" />
    </section>
    <CatalogPagination :result="pagination" @change="changePageData" @addMore="getMoreItems" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import StocksCard from '@components/Stocks/StocksCard.vue';
import CatalogPagination from '@components/Catalog/CatalogPagination.vue';

export default {
  name: 'Stocks',
  components: { CatalogPagination, StocksCard, DefTitle, DefBreadCrumbs },
  computed: {
    ...mapState({
      items: ({ catalog }) => catalog?.data?.catalogSectionList?.items,
      messages: ({ results }) => results?.messages,
      pagination: ({ catalog }) => catalog?.data?.catalogSectionList?.pagination,
    }),
  },
  methods: {
    ...mapActions({
      changePageData: 'catalog/changePageData',
      getMoreItems: 'catalog/getMoreItems',
    }),
  },
};
</script>

<style lang="scss" scoped>
.stocks {
  margin-bottom: 64px;
  @include point-lg {
    margin-bottom: 80px;
  }
  &__items {
    display: grid;
    grid-gap: 16px;
    margin-bottom: 24px;
    @include point-md {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-gap: 24px;
    }
    @include point-lg {
      grid-gap: 32px;
      margin-bottom: 40px;
    }
  }
}
</style>
